import React, { useState } from "react";
import "../Styles/auth.css";
import logo from "../asset/Image/logo.png";
import logoBlack from "../asset/Image/logo1.png";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { Link } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../util/axios";

const Login = () => {
  window.localStorage.clear();

  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevVisible) => !prevVisible);
  };

  const [sign, setSign] = useState({
    email: "",
    password: "",
  });

  const handleChange = ({ target: { name, value } }: any) => {
    setSign({ ...sign, [name]: value });
  };

  const handleSubmit = (e: any) => {
    setLoading(true);
    e.preventDefault();

    api
      .post("/auth/login/business", {
        email: sign.email,
        password: sign.password,
      })
      .then((res: any) => {
        toast.success("Login Successful");
        window.localStorage.setItem("token", res.data.data.token);
        window.localStorage.setItem(
          "userData",
          JSON.stringify(res.data.data.data)
        );
        window.localStorage.setItem("userRole", res.data.data.data.account.role);
        setTimeout(() => {
          setLoading(false);
          navigate("/dashboard");
        }, 1500);
      })
      .catch((err: any) => {
        toast.error(err?.response?.data?.message);
        setLoading(false);
      });
  };

  return (
    <div className="auth">
      <ToastContainer />
      <div className="left">
        <div>
          <img src={logo} alt="" />

          <div className="leftCon">
            <h2>Business Login</h2>
            <p>Welcome to One flare inventory solution</p>
            <form onSubmit={handleSubmit}>
              <div className="input">
                <label>Email</label>
                <input
                  className="inputField"
                  type="email"
                  placeholder="example@email.com"
                  name="email"
                  value={sign.email}
                  required
                  onChange={handleChange}
                />
              </div>
              <div className="input">
                <label>Password</label>
                <div className="inputPass">
                  <input
                    type={passwordVisible ? "text" : "password"}
                    placeholder="********"
                    name="password"
                    required
                    value={sign.password}
                    onChange={handleChange}
                  />
                  {passwordVisible ? (
                    <AiFillEyeInvisible
                      className="loginEye"
                      onClick={togglePasswordVisibility}
                    />
                  ) : (
                    <AiFillEye
                      className="loginEye"
                      onClick={togglePasswordVisibility}
                    />
                  )}
                </div>
                <Link to="/forgot-password" className="forget">
                  Forgot Password?
                </Link>
              </div>

              <button type="submit">
                {loading ? (
                  <CircularProgress
                    style={{ color: "#fff", width: "25px", height: "25px" }}
                  />
                ) : (
                  "Login"
                )}
              </button>
            </form>
            <Link to="/signup" className="acc pb-5">
              Don't have an account yet? <span> Sign Up</span>
            </Link>

            <Link to="/stafflogin" className="staff ">
              Login as a <h3>Staff</h3>
            </Link>
          </div>
        </div>


      </div>

      <div className="right">
        <div className="rightCon">
          <h4>Oneflare Business Suite</h4>

          <h2>
            Help manage your <span> inventory </span> with <span> Ease </span> &
            Get up to date <span className="rep">reports</span>
          </h2>

          <p>It’s that simple</p>
        </div>

        <img src={logoBlack} alt="" className="logoBottom" />
      </div>
    </div>
  );
};

export default Login;
